module.exports = __webpack_public_path__ + "assets/img/5.ae25d297.png";